<!--
 * @Description: app版本管理
 * @Author: cxh
 * @Date: 2023-05-19 10:23:20
 * @LastEditTime: 2023-05-19 14:00:02
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table :columns="columns" @fetch="getList" ref="tableRef" :needPage="false" tableId="DcCosSystemAppVersion">
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button type="link" v-permission="'sys_app_version_edit_btn'" @click="handleEdit(record)">编辑</a-button>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 编辑 -->
  <ModalForm ref="modalFormRef" @fetch="fetchTable" />
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import ModalForm from './components/ModalForm.vue'
import { getAppVersion } from '@/api/systemSetting/index'
import type { AppVersionItem } from '@/typings/api/systemSetting'

const tableRef = ref()
const modalFormRef = ref<any>()
const columns = computed(() => [
  {
    title: '操作系统',
    dataIndex: 'osType'
  },
  { title: '当前版本', dataIndex: 'currVersion' },
  { title: '最小版本号', dataIndex: 'minVersion' },
  { title: '最大版本号', dataIndex: 'maxVersion' },
  { title: '内容', dataIndex: 'content' },
  { title: '操作人', dataIndex: 'operatorName' },
  { title: '操作时间', dataIndex: 'operationTime', width: 190 },

  {
    title: '操作',
    dataIndex: 'action',
    width: 150,
    fixed: 'right'
  }
])

const getList = (queryForm: object, callBack: (res: any) => void) => {
  getAppVersion().then((res) => {
    callBack(res)
  })
}
const fetchTable = () => tableRef.value.fetch()
const handleEdit = (rows: AppVersionItem) => {
  modalFormRef.value?.init(rows)
}
</script>
<script lang="ts">
export default { name: 'DcCosSystemMapManage' }
</script>

<style scoped></style>
